import { useMasterContext } from 'provider/MasterProvider';
import Select from 'react-select';
import { FormControl } from "react-bootstrap";
import React, { useState } from 'react';
import rupeeFormat from "components/Api/RupeeFormat";
import { initialFilterSafariPackagesParkWise } from 'Data/safariPackages';
import { useParksViewContext } from 'provider/ParkViewProvider';

const ParkPackagesMobileFilter = ({ onCancel }) => {
    const { filters, parksViewDispatch } = useParksViewContext();
    const { months, safariCategory, packageFeature, packageInclude, safariPackSortBy, masterLoading } = useMasterContext();
    const [nightMin, setNightMin] = useState(0);
    const [nightMax, setNightMax] = useState(10);
    const [safariMin, setSafariMin] = useState(0);
    const [safariMax, setSafariMax] = useState(10);
    const [costMin, setCostMin] = useState(1000);
    const [costMax, setCostMax] = useState(50000);

    const updateFilter = (name, value) => {
        parksViewDispatch({
            type: "UPDATE_PARKS_VIEW_PACKAGE_FILTER",
            payload: { [name]: value },
        });
    };
    const clearFilter = (name, value) => {
        parksViewDispatch({
            type: "UPDATE_PARKS_VIEW_PACKAGE_FILTER",
            payload: initialFilterSafariPackagesParkWise,
        });
    };
    return (
        <>
            <div className="filterPhone  custoM-inputs">
                <div className="top_filterwrap d-flex align-items-center justify-content-between">
                    <div className="title_top">
                        <h4 className="mb-0">Select Filters</h4>
                    </div>
                    <div className="apply-btn d-flex gap-2">
                        <button className="btn_apply" onClick={clearFilter} style={{ background: '#a0a7a5', color: '#fff' }}>clear</button>
                        <button className="btn_apply" onClick={onCancel} style={{ background: '#09422d', color: '#fff' }}>Cancel</button>
                        <button className="btn_apply" onClick={onCancel}>Apply</button>
                    </div>
                </div>
                <div className="searchwrap mb-3 mt-5 pt-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6 className="mb-0">Sort By</h6>
                            </div>
                        </div>
                        <div className="col-7">

                            <Select
                                id="packagesearch-custom_sort_by"
                                classNamePrefix="custom_sort_by_input"
                                value={
                                    safariPackSortBy?.find(option => Number(option.value) === Number(filters?.custom_sort_by)) || null
                                }
                                onChange={(selectedOption) =>
                                    updateFilter('custom_sort_by', selectedOption?.value || '')
                                }
                                options={safariPackSortBy || []}
                                isSearchable
                                isClearable
                                isDisabled={masterLoading}
                                placeholder={masterLoading ? "Loading..." : "Select Sort Option"}
                                components={{ IndicatorSeparator: () => null }}
                            />
                        </div>
                    </div>
                </div>
                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Month</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="input_check ">
                                <Select
                                    value={months?.find(p => p.value === filters?.month_id) || null}
                                    onChange={(selectedOption) => updateFilter('month_id', selectedOption?.value || 0)}
                                    options={months}
                                    isSearchable
                                    isClearable
                                    components={{ IndicatorSeparator: () => null }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Stay Category</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="input_check ">
                                {safariCategory.map(budget => (
                                    <div className="d-flex align-items-center pt-1" key={budget.value}>
                                        <input
                                            id={`stay-category-${budget.value}`}
                                            type="checkbox"
                                            className="type checkbox_design me-3"
                                            name="stay_category_id"
                                            value={budget.value}
                                            checked={Array.isArray(filters?.stay_category_id) && filters.stay_category_id.includes(budget.value)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                const current = filters?.stay_category_id || [];
                                                const newValues = checked
                                                    ? [...current, budget.value]
                                                    : current.filter(v => v !== budget.value);
                                                updateFilter("stay_category_id", newValues);
                                            }}
                                        />
                                        <label htmlFor={`stay-category-${budget.value}`}>{budget.label}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Tour Duration</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="multi-range">
                                <FormControl
                                    type="range"
                                    min="1"
                                    max="10"
                                    className="dual_range"
                                    name="no_of_night_min"
                                    value={Math.max(filters?.no_of_night_min || 0,1)}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        const max = filters?.no_of_night_max || 10;
                                        if (val <= max) {
                                            setNightMin(val);
                                            updateFilter("no_of_night_min", val);
                                        }
                                    }}
                                />
                                <FormControl
                                    type="range"
                                    min="1"
                                    max="10"
                                    className="dual_range"
                                    name="no_of_night_max"
                                    value={Math.max(filters?.no_of_night_max || 10)}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        const min = filters?.no_of_night_min || 1;
                                        if (val >= min) {
                                            setNightMax(val);
                                            updateFilter("no_of_night_max", val);
                                        }
                                    }}
                                />
                            </div>
                            <div className="range-label">
                                <span className="value">{Math.max(filters?.no_of_night_min || 0, 1)} Night</span>
                                <span className="float-end">{Math.max(filters?.no_of_night_max || 10)}+ Nights</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Total Safaris</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="multi-range">
                                <FormControl
                                    type="range"
                                    min="1"
                                    max="10"
                                    className="dual_range"
                                    name="no_of_safari_min"
                                    value={Math.max(filters?.no_of_safari_min || 0, 1)}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        const max = filters?.no_of_safari_max || 10;
                                        if (val <= max) {
                                            setSafariMin(val);
                                            updateFilter("no_of_safari_min", val);
                                        }
                                    }}
                                />
                                <FormControl
                                    type="range"
                                    min="1"
                                    max="10"
                                    className="dual_range"
                                    name="no_of_safari_max"
                                    value={Math.max(filters?.no_of_safari_max || 10, 1)}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        const min = filters?.no_of_safari_min || 1;
                                        if (val >= min) {
                                            setSafariMax(val);
                                            updateFilter("no_of_safari_max", val);
                                        }
                                    }}
                                />
                            </div>
                            <div className="range-label">
                                <span className="value">{Math.max(filters?.no_of_safari_min || 0, 1)}</span>
                                <span className="float-end">{Math.max(filters?.no_of_safari_max || 10, 1)}+</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Cost (Per Person)</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="multi-range">
                                <FormControl
                                    type="range"
                                    step="100"
                                    min={1000}
                                    max={50000}
                                    className="dual_range"
                                    name="estimated_price_filter_min"
                                    value={filters?.estimated_price_filter_min || 1000}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        const max = filters?.estimated_price_filter_max || 50000;
                                        const newMin = Math.min(val, max - 100);
                                        setCostMin(newMin);
                                        updateFilter("estimated_price_filter_min", newMin);
                                    }}
                                />
                                <FormControl
                                    type="range"
                                    step="100"
                                    min={1000}
                                    max={50000}
                                    className="dual_range"
                                    name="estimated_price_filter_max"
                                    value={filters?.estimated_price_filter_max || 50000}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        const min = filters?.estimated_price_filter_min || 1000;
                                        const newMax = Math.max(val, min + 100);
                                        setCostMax(newMax);
                                        updateFilter("estimated_price_filter_max", newMax);
                                    }}
                                />
                            </div>
                            <div className="range-label">
                                <span className="value">₹{rupeeFormat(Math.max(filters?.estimated_price_filter_min || 0, 1000))}</span>
                                <span className="float-end">₹{rupeeFormat(Math.max(filters?.estimated_price_filter_max || 50000, 0))}+</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Features</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="input_check ">
                                {packageFeature.map(feature => (
                                    <div className="d-flex align-items-center pt-1" key={feature.value}>
                                        <input
                                            type="checkbox"
                                            className="type checkbox_design me-3"
                                            name="package_feature"
                                            id={`package-feature-${feature.value}`}
                                            value={feature.value}
                                            checked={Array.isArray(filters?.package_feature) && filters.package_feature.includes(feature.value)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                const current = filters?.package_feature || [];
                                                const newValues = checked
                                                    ? [...current, feature.value]
                                                    : current.filter(v => v !== feature.value);
                                                updateFilter("package_feature", newValues);
                                            }}
                                        />
                                        <label htmlFor={`package-feature-${feature.value}`}>{feature.label}</label>
                                    </div>
                                ))}

                            </div>

                        </div>
                    </div>
                </div>
                <div className="searchwrap mb-3">
                    <div className="row align-items-center">
                        <div className="col-5">
                            <div className="title_filter">
                                <h6>Included</h6>
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="input_check ">
                                {packageInclude.map(feature => (
                                    <div className="d-flex align-items-center pt-1" key={feature.value}>
                                        <input
                                            type="checkbox"
                                            className="type checkbox_design me-3"
                                            name="package_include"
                                            id={`package-include-${feature.value}`}
                                            value={feature.value}
                                            checked={Array.isArray(filters?.package_include) && filters.package_include.includes(feature.value)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                const current = filters?.package_include || [];
                                                const newValues = checked
                                                    ? [...current, feature.value]
                                                    : current.filter(v => v !== feature.value);
                                                updateFilter("package_include", newValues);
                                            }}
                                        />
                                        <label htmlFor={`package-include-${feature.value}`}>{feature.label}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ParkPackagesMobileFilter
